<template>
  <v-col>
    <d-header :label="quoteId ? 'Edit Quote' : 'New Quote'" />
    <v-row justify="space-between" class="px-3">
      <v-row>
        <g-button class="mr-3" label="Cancel" @onclick="goback" />
        <v-menu offset-y v-if="quoteId">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              small
              outlined
              class="mr-3"
              color="primary"
              style="background: white"
              v-bind="attrs"
              v-on="on"
            >
              Generate
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-for="(item, index) in generateItems" :key="index" @click="item.action">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y v-if="quoteId">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              small
              outlined
              class="mr-3"
              color="primary"
              style="background: white"
              v-bind="attrs"
              v-on="on"
            >
              Options <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item v-for="(item, index) in optionItems" :key="index" @click="item.action">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
      <div>
        <v-row>
          <g-button
            v-if="quoteId"
            class="mr-3"
            label="Duplicate"
            :disabled="isSubmitDisabled"
            @onclick="duplicateQuote"
          />
          <delete-button v-if="quoteId" class="mr-3" :ondelete="deleteQuote" />
          <g-button v-if="quoteId" label="Save" @onclick="submitQuote" />
          <g-button v-else label="Create" @onclick="submitQuote" />
        </v-row>
      </div>
    </v-row>

    <PaxInputDialog
      v-model="isPaxInputDialogShowed"
      :peopleRanges="peopleRanges"
      :periodOptions="periodOptions"
      :defaultPeriodKey="defaultPeriodKey"
      @generate="(v) => exportDetailToExcel(v)"
    />
  </v-col>
</template>

<script>
import PaxInputDialog from "./PaxInputDialog";
export default {
  components: {
    PaxInputDialog,
  },
  props: {
    quoteId: {
      type: String,
      default: null,
    },
    peopleRanges: Array,
    periodOptions: {
      type: Array,
      default: () => [],
    },
    defaultPeriodKey: {
      type: String,
      default: "primary",
    },
    isSubmitDisabled: Boolean,
    onGenerateToBooking: Function,
    onExportOverviewToExcel: Function,
    onExportDetailToExcel: Function,
    onOverviewOptions: Function,
    onProgramContent: Function,
    onDiscountMargin: Function,
    onNotes: Function,
    onSubmit: Function,
    onDelete: Function,
    onDuplicate: Function,
  },
  data() {
    return {
      isPaxInputDialogShowed: false,
      generateItems: [
        { title: "Booking", action: this.generateBooking },
        { title: "Quote Document", action: this.exportOverviewToExcel },
        { title: "Itemized Quote Document", action: this.showPaxInputDialog },
      ],
      optionItems: [
        { title: "Trip Inclusions", action: this.overviewOptions },
        { title: "Notes", action: this.notes },
        { title: "Discount Margin", action: this.discountMargin },
        { title: "Program", action: this.programContent },
      ],
    };
  },
  methods: {
    goback() {
      this.$router.push({ name: "quotes" });
    },
    generateBooking() {
      return this.onGenerateToBooking();
    },
    exportOverviewToExcel() {
      return this.onExportOverviewToExcel();
    },
    exportDetailToExcel(payload) {
      return this.onExportDetailToExcel(payload);
    },
    overviewOptions() {
      return this.onOverviewOptions();
    },
    programContent() {
      return this.onProgramContent();
    },
    discountMargin() {
      return this.onDiscountMargin();
    },
    notes() {
      return this.onNotes();
    },
    submitQuote() {
      return this.onSubmit();
    },
    deleteQuote() {
      return this.onDelete();
    },
    duplicateQuote() {
      return this.onDuplicate();
    },
    showPaxInputDialog() {
      this.isPaxInputDialogShowed = true;
    },
  },
};
</script>
